/**
 * Flattens a string|{pill} segments array (templates.js/resetToSegments' own shape) into one
 * plain string -- the read-only counterpart to useSegments.js's own `flattenedText` (which
 * operates on its internal `{type, value/display}` segment objects, not this raw shape, and
 * isn't reachable outside a mounted TokenizedSearchInput). Same gap-filling rule: a space is
 * inserted between two adjacent pieces only if neither side already has one, so two pills
 * committed back-to-back read naturally instead of running together.
 */
export function segmentsToText(segments) {
  return (Array.isArray(segments) ? segments : []).reduce((acc, piece) => {
    const text = typeof piece === "string" ? piece : piece?.pill ?? "";
    if (!text) return acc;
    const needsSpace = acc.length > 0 && !/\s$/.test(acc) && !/^\s/.test(text);
    return acc + (needsSpace ? " " : "") + text;
  }, "");
}
